// extracted by mini-css-extract-plugin
module.exports = {"WinLoseWrapper":"WinLoseWrapper-module--WinLoseWrapper--1rZyo"};